module.exports = __webpack_public_path__ + "media/images/emoticons/downwardleft-00fb28b12163b5ccdb6c26dbb9f6033b.gif";